import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import SpinnerComponent from '../layout/spinner';
import { post, construirMensaje } from "../../helpers/apiHttp";

const RegistrarContracargo = ({ show, handleClose, stores, busqueda }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formulario, setFormulario] = useState({
    serie: "",
    order_name: "",
    classification: "",
    reason: "",
    observation: ""
  });

  const resetFormulario = () => {
    setFormulario({
      serie: "",
      order_name: "",
      classification: "",
      reason: "",
      observation: ""
    });
  };

  useEffect(() => {
    if (show) {
      resetFormulario();
    }
  }, [show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormulario((prevFormulario) => ({
      ...prevFormulario,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    if (!formulario.serie) {
      construirMensaje('', 'Debe seleccionar una tienda', 'warning');
      return;
    }

    if (!formulario.order_name) {
      construirMensaje('', 'Debe ingresar el número de orden', 'warning');
      return;
    }

    if (!formulario.classification) {
      construirMensaje('', 'Debe seleccionar una clasificación', 'warning');
      return;
    }

    const confirm = await Swal.fire({
      title: '¿Registrar contracargo?',
      text: `Se registrará la orden ${formulario.order_name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, registrar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirm.isConfirmed) return;

    const formData = new FormData();
    formData.append('serie', formulario.serie);
    formData.append('order_name', formulario.order_name);
    formData.append('classification', formulario.classification);
    formData.append('reason', formulario.reason);
    formData.append('observation', formulario.observation);

    try {
      setIsSubmitting(true);
      setIsLoading(true);

      const data = await post('risk/chargebacks', formData);

      setIsLoading(false);

      if (data.isSuccessful === true && data.statusCode === 201) {
        construirMensaje(
          'Contracargo registrado correctamente',
          'Proceso completado',
          'success'
        );

        busqueda();
        handleClose();
      } else {
        construirMensaje(data.errorMessage, 'Error durante el proceso', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);

      Swal.fire({
        icon: 'error',
        title: 'Error de formulario',
        text: 'Error al registrar el contracargo',
        footer: ''
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <SpinnerComponent />
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Registrar contracargo</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleSubmit} encType="multipart/form-data">
              <Form.Group className="mb-3">
                <Form.Label>Tienda</Form.Label>
                <Form.Select
                  name="serie"
                  value={formulario.serie}
                  onChange={handleChange}
                >
                  <option value="">Seleccione una tienda</option>
                  {stores.map((store) => (
                    <option key={store.id} value={store.prefix}>
                      {store.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>No Orden</Form.Label>
                <Form.Control
                  type="text"
                  name="order_name"
                  placeholder="Ej: #1055"
                  value={formulario.order_name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Clasificación</Form.Label>
                <Form.Select
                  name="classification"
                  value={formulario.classification}
                  onChange={handleChange}
                >
                  <option value="">Seleccione una clasificación</option>
                  <option value="LEGITIMATE_CHARGEBACK">
                    Contracargo legítimo
                  </option>
                  <option value="FRAUD_SUSPECTED">
                    Sospecha de fraude
                  </option>
                  <option value="FRAUD_CONFIRMED">
                    Fraude confirmado
                  </option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Motivo</Form.Label>
                <Form.Select
                  name="reason"
                  value={formulario.reason}
                  onChange={handleChange}
                >
                  <option value="">Seleccione motivo</option>
                  <option value="No recibió el producto">No recibió el producto</option>
                  <option value="Compra no reconocida">Compra no reconocida</option>
                  <option value="Producto diferente">Producto diferente</option>
                  <option value="Producto defectuoso">Producto defectuoso</option>
                  <option value="Otro">Otro</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Observación</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="observation"
                  placeholder="Observación del caso"
                  value={formulario.observation}
                  onChange={handleChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>

            <Button
              variant="primary"
              type="submit"
              disabled={isSubmitting}
              onClick={handleSubmit}
            >
              Registrar contracargo
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default RegistrarContracargo;